export default __webpack_public_path__ + "static/1home-server-ch-dce586bd2df87d18bea20e8bfeefd98d.webp";